import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import CollectionSection from './CollectionSection';
import BrandsCarousel from './BrandsCarousel';
import PartnersSection from './PartnersSection';
import Footer from './Footer';
import AnimatedBear from './AnimatedBear';
import FloatingBadge from './FloatingBadge';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <AnimatedBear />
      <FloatingBadge />
      <HeroSection />
      <CollectionSection />
      <BrandsCarousel />
      <PartnersSection />
      <Footer />
    </div>
  );
};

export default LandingPage;